import React from 'react';
import {WithPermission} from 'admin-on-rest';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import POSUserTypePermissionsList from '../components/POSUserTypePermissionsList';
import {resolveAccess} from '../shared/authFunctions';
import {Card, CardHeader, CardText, CardActions} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import Avatar from 'material-ui/Avatar';
import ListIcon from 'material-ui/svg-icons/action/view-list';
import AddIcon from 'material-ui/svg-icons/content/add';
import UserIcon from 'material-ui/svg-icons/social/person';
import {fusePosUserTypeIcon as POSUserTypeIcon} from './posUserType';
import {fusePosUserIcon as POSUserIcon} from './posUser';
import {dashStyles} from '../shared/styles-dashboard';

export default () => (
    <div>
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['pos_users', 'pos_users_vo'])}>
            <Card style={{...dashStyles.marginBottom}}>
                <UserIcon style={dashStyles.dashIcon}/>
                <ViewTitle title="Users"/>
                <CardText>
                    <WithPermission
                        resolve={(props) => resolveAccess(props.permissions, ['pos_users'])}>
                        <p>
                            Create and Manage all of your POS, Admin and Reports Users for your Business.
                        </p>
                    </WithPermission>
                    <WithPermission
                        resolve={(props) => resolveAccess(props.permissions, [], ['pos_users_vo'])}>
                        <p>
                            View all of your POS, Admin and Reports Users for your Business.
                        </p>
                    </WithPermission>
                    <img src="img-diagram-POS-Users-List.png" alt="Diagram of POS Users Tree"
                         style={dashStyles.diagram}/>
                </CardText>
            </Card>
        </WithPermission>

        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['pos_users', 'pos_users_vo'])}>
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}} className="listCard">
                <CardHeader
                    title="POS User Types"
                    subtitle="POS User Types are assigned to POS Users to give them specific permissions on the POS System. Click to read more."
                    avatar={<Avatar icon={<POSUserTypeIcon/>} style={dashStyles.avatar}/>}
                    actAsExpander={true}
                    showExpandableButton={true}
                />
                <CardText expandable={true}>
                    <POSUserTypePermissionsList/>
                </CardText>
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="List POS User Types" href="#/POSUserTypes"/>
                </CardActions>
            </Card>
        </WithPermission>

        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['pos_users', 'pos_users_vo'])}>
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}} className="listCard">
                <CardHeader
                    title="POS Users"
                    subtitle="POS Users are users with permissions for logging into the POS System."
                    avatar={<Avatar icon={<POSUserIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <WithPermission
                        resolve={(props) => resolveAccess(props.permissions, ['pos_users'])}>
                        <FlatButton icon={<ListIcon/>} label="List POS Users" href="#/POSUsers"/>
                        <FlatButton icon={<AddIcon/>} label="Add a POS User" href="#/POSUsers/create"/>
                    </WithPermission>
                    <WithPermission
                        resolve={(props) => resolveAccess(props.permissions, [], ['pos_users_vo'])}>
                        <FlatButton icon={<ListIcon/>} label="List POS Users" href="#/POSUsers"/>
                    </WithPermission>
                </CardActions>
            </Card>
        </WithPermission>
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/User/posUserDashboard.js